module.exports = __webpack_public_path__ + "img/fr_true_gem_page.c3b61abd.png";